<template>
    <DataTable
            v-redirect-if-no-permission:TYPES
            :url="api.ACTIONS.BANKS"
            :fieldsHiddenMain='["deleted_at"]'
            :fieldsHiddenAdd='["created_at","deleted_at","updated_at","id"]'
            :fieldsDisabledEdit='["created_at","deleted_at","updated_at","id"]'
            :fieldsExtraAdd="{name : 'v-text-field'}"
            :titles="titles"
            :add-rules="{name: [val => !!val || $t('common.required')]}"
            :title="$t('drivers.banks.title')"/>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";

    export default {
        name: "Banks",
        title() { return this.$t("drivers.banks.title"); },
        components: {DataTable},
        computed: {
            titles() {
                return {
                    "id": "#",
                    "name": this.$t("common.name"),
                    "created_at": this.$t("drivers.banks.createdAt"),
                    "updated_at": this.$t("drivers.banks.updatedAt")

                }
            }
        }
    }
</script>

<style scoped>

</style>